import { APIS } from "../endpoints";
import api from "./api";

// Returns true when the filter payload has no user-applied selections.
// Backend treats any non-empty `filters` query param as a filtered query and
// returns an empty result, so we OMIT the param entirely on initial loads
// (default state: empty filters object + default sortBy_v + empty search).
const _isDefaultFilterOptions = (opts) => {
  if (!opts || typeof opts !== "object") return true;
  const filters = opts.filters;
  const hasFilterValues =
    filters &&
    typeof filters === "object" &&
    Object.values(filters).some((v) =>
      Array.isArray(v) ? v.length > 0 : Boolean(v),
    );
  if (hasFilterValues) return false;
  if (opts.search) return false;
  return true;
};

export const getAuditLogData = async (
  page,
  limit,
  searchText,
  filterOptions = {},
) => {
  const formData = new FormData();
  formData.append("page", page);
  formData.append("limit", limit);

  if (!_isDefaultFilterOptions(filterOptions)) {
    const cleanedOptions = {
      ...filterOptions,
      filters: Object.fromEntries(
        Object.entries(filterOptions.filters || {}).filter(([, v]) =>
          Array.isArray(v) ? v.length > 0 : Boolean(v),
        ),
      ),
    };
    formData.append("filters", JSON.stringify(cleanedOptions));
  }

  if (searchText) {
    formData.append("search", searchText); // Add search term
  }
  const params = new URLSearchParams(formData);
  const result = await api.get(`${APIS.BASE_URL}${APIS.auditLog}`, {
    params: params,
  });

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getAuditLogById = async (id) => {
  try {
    const result = await api.get(`${APIS.BASE_URL}${APIS.auditLog}`, {
      params: { id: id },
    });

    if (result) {
      return result?.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching audit log by ID:", error);
    throw error;
  }
};
